module.exports = __webpack_public_path__ + "media/images/chat_close-8ef060fb3ed0982588618f8475311e92.png";